export const formatNumber = (number, locale, minimumFractionDigits = 0, maximumFractionDigits = 0) => {
    return number.toLocaleString(locale, { minimumFractionDigits , maximumFractionDigits })
}